import { ReactElement } from 'react';
import { ProductKind, type ActivityType } from 'types';
import { useField } from '@ff-it/form';
import invariant from 'tiny-invariant';
import type { ProductFormConfig } from './types';
import { ProductBaseFields } from './ProductBaseFields';
import { OutletOrServiceCategory } from '../outletOrServiceCategory/types';

interface FormProps {
  outletOrServiceCategory: OutletOrServiceCategory;
  /** Activity type selected by the route scope. */
  typeScope: ActivityType;
  /** Type-owned configuration form resolved by the route composition root. */
  formConfig?: ProductFormConfig;
}

export function Form({ outletOrServiceCategory, typeScope, formConfig }: FormProps): ReactElement {
  const {
    input: { value: type },
  } = useField<ActivityType | null>('type', { subscription: { value: true }, allowNull: true });
  invariant(type === typeScope);

  const {
    input: { value: kind },
  } = useField<ProductKind | null>('kind', { subscription: { value: true }, allowNull: true });

  return (
    <div className="container px-0 ml-0">
      <ProductBaseFields
        kind={kind}
        type={typeScope}
        vendorId={outletOrServiceCategory.vendor_id}
        config={formConfig}
        showServiceGrossPrice={outletOrServiceCategory.kind === 'OUTLET'}
      />
    </div>
  );
}
